import { Link } from "react-router-dom";
import { Spinner } from "@heroui/react";
import { ChartLineUp } from "@phosphor-icons/react";
import { applyMask } from "shared/utils/masks";
import { DashboardBlock, DashboardBlockHeader, DashboardBlockContent } from "../layout/DashboardBlock";
import { blockStyles } from "../utils/blockStyles.utils";

interface SummaryMetricsBlockNewProps {
  keyFigures: any;
  formattedOPEXValue: string;
  weeklyCompletedTasksByUser: number;
  weeklyCompletedTasksByEveryone: number;
}

export const SummaryMetricsBlockNew = ({
  keyFigures,
  formattedOPEXValue,
  weeklyCompletedTasksByUser,
  weeklyCompletedTasksByEveryone,
}: SummaryMetricsBlockNewProps) => {
  return (
    <DashboardBlock>
      <DashboardBlockHeader
        icon={<ChartLineUp weight="duotone" size={20} />}
        title="Yally metrics"
      />
      <DashboardBlockContent>
        <ul className={blockStyles.list.container}>
          <li className={blockStyles.list.item}>
            <Link to="https://portal.yally.be/web#action=270&model=account.move&view_type=list&menu_id=291&cids=1%2C2%2C3%2C4">
              <div className="flex items-center justify-between mb-1">
                <span className={blockStyles.list.itemLabel}>Afgesloten huurcontracten dit jaar</span>
                <span className={blockStyles.list.itemValue}>
                  {keyFigures.contractsCreatedThisYear || <Spinner size="sm" color="warning" />}
                </span>
              </div>
              {keyFigures.contractsCreatedThisYearValue !== undefined && (
                <div className={blockStyles.list.itemSubtext}>
                  = {applyMask(keyFigures.contractsCreatedThisYearValue, "valuta")} / YTD totaal
                </div>
              )}
            </Link>
          </li>
          
          <li className={blockStyles.list.item}>
            <Link to="https://portal.yally.be/web#action=270&model=account.move&view_type=list&menu_id=291&cids=1%2C2%2C3%2C4">
              <div className="flex items-center justify-between">
                <span className={blockStyles.list.itemLabel}>Openstaande klantenfacturen</span>
                <span className={blockStyles.list.itemValue}>
                  {(keyFigures.currentUnpaidRent && applyMask(keyFigures.currentUnpaidRent, "valuta")) || <Spinner size="sm" color="warning" />}
                </span>
              </div>
            </Link>
          </li>

          <li className={blockStyles.list.item}>
            <Link to="/tasks">
              <div className="flex items-center justify-between mb-1">
                <span className={blockStyles.list.itemLabel}>Afgewerkte taken deze week</span>
                <span className={blockStyles.list.itemValue}>
                  {weeklyCompletedTasksByUser} door jou
                </span>
              </div>
              <div className={blockStyles.list.itemSubtext}>
                {weeklyCompletedTasksByEveryone} door heel het team
              </div>
            </Link>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between">
              <span className={blockStyles.list.itemLabel}>Gebouwen in portefeuille</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.numBuildings && keyFigures.numBuildings) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between">
              <span className={blockStyles.list.itemLabel}>Units in portefeuille</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.numUnits && keyFigures.numUnits !== 0 && keyFigures.numUnits) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between mb-1">
              <span className={blockStyles.list.itemLabel}>OPEX kosten</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.nonChargeableOpexCosts && applyMask(keyFigures.nonChargeableOpexCosts, "valuta")) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
            <div className={blockStyles.list.itemSubtext}>
              {formattedOPEXValue}% van geïnde huur excl. provisies
            </div>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between">
              <span className={blockStyles.list.itemLabel}>CAPEX kosten dit jaar</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.capexCosts && applyMask(keyFigures.capexCosts, "valuta")) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between mb-1">
              <span className={blockStyles.list.itemLabel}>Totaal klantenfacturen</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.currentInvoicedRent && applyMask(keyFigures.currentInvoicedRent, "valuta")) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
            <div className={blockStyles.list.itemSubtext}>
              Waarvan {applyMask(Math.abs(keyFigures.invoicedRentLines || 0), "valuta")} huur
            </div>
          </li>

          <li className={blockStyles.list.item}>
            <div className="flex items-center justify-between mb-1">
              <span className={blockStyles.list.itemLabel}>Acquisitiedossiers in pipeline</span>
              <span className={blockStyles.list.itemValue}>
                {(keyFigures.acquisitionsInPipeline && keyFigures.acquisitionsInPipeline) || (<Spinner size="sm" color="warning" />)}
              </span>
            </div>
            <div className={blockStyles.list.itemSubtext}>
              <Link to="/acquisitions" className={blockStyles.link.variants.primary}>Bekijk pipeline →</Link>
            </div>
          </li>
        </ul>
      </DashboardBlockContent>
    </DashboardBlock>
  );
};

